import {
    ConfigViewType,
    ItemListView,
    NodeTypeName,
    ObjectClass
} from "@app/types";
import BaseNodeModel from "../BaseNodeModel";

export default class SessionCompletionNodeModel extends BaseNodeModel {
    /**
     * Input node model
     * @module SessionCompletionNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.sessionCompletion;
        this.props.colorClass = "yellow";
        this.props.iconClass = "corner-left-down";
        // default configuration fileds
        this.props.config = {};
        this.props.config["description"] = props.config.description || '';
        this.props.config["timeoutSeconds"] = props.config.timeoutSeconds || 30;
        this.props.config["startSimultaneousSessionNode"] = props.config.startSimultaneousSessionNode || null;
        this.props.config["channelName"] = props.config.channel || '';
        this.props.config["blockProgress"] = props.config.blockProgress || false;
        
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.applyProps(props);
    }

    setConfig(key, value) {
        if(key === "startSimultaneousSessionNode" && value.length === 36){ 
            // this is where you update the startSessionNode amd channel fileds
            const sessionNode = this.getStartSessionNodeInstances().find(node => node.node.id === value).node;
            const { channelName } = sessionNode.props.config;

            //super.setConfig(key, combinedName);
            super.setConfig(key, value);
            super.setConfig("channelName", channelName);
        } if(key === "timeoutSeconds"){
            //Timeout has to be parsed back into an integer when being edited
            super.setConfig(key, parseInt(value));
        } else {
            
            super.setConfig(key, value);
        }
        
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        
    }

    getStartSessionNodeInstances() {
        const modules = window.apm.serialized.components.modules;
        const relevantModules = modules.filter((mod) => mod.versions && mod.versions["1"])
            .map((mod) => ({
                id: mod.id,
                name: mod.name,
                flow: mod.versions["1"].flow
            }));

        const relevantStartSessionNodes = relevantModules.reduce(function (acc, mod) {
            if (!mod.flow || !mod.flow.nodes || !mod.flow.nodes.length) {
                return acc;
            }

            mod.flow.nodes.filter(node => node._class == ObjectClass.session)
                .forEach(function (node) {
                    let startSessionNodeEntry = {
                        name: `${node.name}_${node.props.config.channelName} (${mod.name})`,
                        value: node.id,
                        node: node
                    };
                    acc.push(startSessionNodeEntry);
                });

            return acc;
        }, []);
        return relevantStartSessionNodes;
    }

    getConfigViews() {
        this.props.configView = [
            { 
                type: "Input", 
                label: "Timeout Seconds", 
                key: "timeoutSeconds", 
                valRules: {"noEmpty": true}, 
                inputRules: {"numberOnly": true } 
            },
            {
                type: "Dropdown", 
                key: "startSimultaneousSessionNode", 
                label: "Start Session Node", 
                optionName: "Select node",
                options: this.getStartSessionNodeInstances()
            },
            {
                type: "Switch", 
                key: "blockProgress", 
                label: "Block Progress", 
                checked: false,
                tooltip: "If enabled, when this node is executed, process engine will wait for an event to be received OR the timeout occurs" 
            },
            {
                type: ConfigViewType.oldItemList,
                label: this.getPropLabel("outputs"),
                key: "outputs",
                view: ItemListView.return
            }
        ];
        return [
            ...this.getConfigViewNameField(),
            ...[
                {type: "Textarea", label: this.getPropLabel("description"), key: "description", valRules: { "noEmpty": true }}
            ],
            ...this.props.configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ]
    }
}
